import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractValueFormulaToken from "./AbstractValueFormulaToken.js";
import ConstantFormulaNode from "../formula/ConstantFormulaNode.js";

/**
 * Token representing a single constant numerical value within a formula.
 *
 * @param {string} spec.value - String representation of the value.
 */
export default class ConstantFormulaToken extends AbstractValueFormulaToken {
	constructor({ value } = {}) {
		super(...arguments);
		this._value = value;
	}

	getValue() {
		return this._value;
	}

	setValue(value) {
		this._value = value;
	}

	accept(visitor) {
		return visitor.visitConstantFormulaToken(this);
	}

	_asBaseFormulaNode() {
		return new ConstantFormulaNode({
			value: this._value,
			type: "Amount",
		});
	}

	static getLabel() {
		return _("Constant");
	}

	static getType() {
		return "constant";
	}
}
